module.exports = __webpack_public_path__ + "img/377.0d0cd043.svg";